import { Component, ContentChildren, Input, OnInit } from '@angular/core';
import { Tab, TabComponent } from './tab/tab.component';

@Component({
  selector: 'std-tabs',
  templateUrl: './tabs.component.html',
  styles: [],
  standalone: false
})
export class TabsComponent {
  @ContentChildren(TabComponent) tabs!: Tab[];
  @Input() type: 'underline' | 'chips' = 'underline';
  @Input() color = 'var(--primary)';
  @Input() containerClass = '';
  @Input() titleClass = '';
  @Input() activeTitleClass = '';

  setActiveTab(tab: Tab) {
    this.tabs.forEach((t: Tab) => (t.active = false));
    tab.active = true;
    tab.titleClick.emit(true);
  }

  getColor() {
    return 'var(--' + this.color + ')';
  }
}
